import React from 'react';
import { BoxIcon, CarIcon, CrownIcon, FeatherIcon, FlaskConicalIcon, GemIcon, HeartIcon, LayersIcon, LeafIcon, PuzzleIcon, RocketIcon, SettingsIcon, ShieldIcon, StarIcon, WrenchIcon, ZapIcon } from 'lucide-react';
import { OverhangsIcon } from './ToolIcons';
import type { ProfileIconId } from '../../types/supportProfiles';
type IconProps = {
  className?: string;
};
function ToothIcon({
  className
}: IconProps) {
  return <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true" data-id="element-251" data-mp="phewfeusd1hn">
      <path d="M7 3c-2.5 0-4 2-4 4.5 0 2 .8 3.4 1.3 5 .6 2 .7 4.5 1.5 6.5.4 1 1.6 1.2 2-.1.6-2 .8-4.4 2.2-4.4s1.6 2.4 2.2 4.4c.4 1.3 1.6 1.1 2 .1.8-2 .9-4.5 1.5-6.5.5-1.6 1.3-3 1.3-5C21 5 19.5 3 17 3c-1.8 0-2.8 1-5 1S8.8 3 7 3z" data-id="element-252" data-mp="lftlhz1taxa3" />
    </svg>;
}
function MiniatureIcon({
  className
}: IconProps) {
  return <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true" data-id="element-253" data-mp="2auhx3y2kwb72">
      <circle cx="12" cy="5" r="2.7" data-id="element-254" data-mp="25voj84jdqi6d" />
      <path d="M8.8 9h6.4l-1.2 4.2 2.2 5.8H7.8l2.2-5.8z" data-id="element-255" data-mp="32eskod6qdwdv" />
      <rect x="6" y="19" width="12" height="3" rx="1" data-id="element-256" data-mp="32gdh68clvped" />
    </svg>;
}
function RingIcon({
  className
}: IconProps) {
  return <svg viewBox="0 0 24 24" className={className} aria-hidden="true" data-id="element-257" data-mp="3ccq8x0olbt6h">
      <circle cx="12" cy="14.5" r="6" fill="none" stroke="currentColor" strokeWidth="2.6" data-id="element-258" data-mp="3cadrqpqnpmuh" />
      <path d="M9 2.5h6l2 2.6-5 3.9-5-3.9z" fill="currentColor" data-id="element-259" data-mp="3harzs7s9cwsi" />
    </svg>;
}
const lucide = (Icon: typeof BoxIcon) => function LucideProfileIcon({
  className
}: IconProps) {
  return <Icon className={className} strokeWidth={2.2} data-id="element-260" data-mp="2one1a58wvt6a" />;
};
export const PROFILE_ICONS: {
  id: ProfileIconId;
  label: string;
  Icon: (props: IconProps) => JSX.Element;
}[] = [{
  id: 'custom',
  label: 'Supports',
  Icon: OverhangsIcon
}, {
  id: 'miniature',
  label: 'Miniature',
  Icon: MiniatureIcon
}, {
  id: 'tooth',
  label: 'Tooth',
  Icon: ToothIcon
}, {
  id: 'cog',
  label: 'Cog',
  Icon: lucide(SettingsIcon)
}, {
  id: 'ring',
  label: 'Ring',
  Icon: RingIcon
}, {
  id: 'cube',
  label: 'Cube',
  Icon: lucide(BoxIcon)
}, {
  id: 'gem',
  label: 'Gem',
  Icon: lucide(GemIcon)
}, {
  id: 'crown',
  label: 'Crown',
  Icon: lucide(CrownIcon)
}, {
  id: 'star',
  label: 'Star',
  Icon: lucide(StarIcon)
}, {
  id: 'heart',
  label: 'Heart',
  Icon: lucide(HeartIcon)
}, {
  id: 'flask',
  label: 'Flask',
  Icon: lucide(FlaskConicalIcon)
}, {
  id: 'layers',
  label: 'Layers',
  Icon: lucide(LayersIcon)
}, {
  id: 'puzzle',
  label: 'Puzzle',
  Icon: lucide(PuzzleIcon)
}, {
  id: 'zap',
  label: 'Lightning',
  Icon: lucide(ZapIcon)
}, {
  id: 'feather',
  label: 'Feather',
  Icon: lucide(FeatherIcon)
}, {
  id: 'shield',
  label: 'Shield',
  Icon: lucide(ShieldIcon)
}, {
  id: 'wrench',
  label: 'Wrench',
  Icon: lucide(WrenchIcon)
}, {
  id: 'rocket',
  label: 'Rocket',
  Icon: lucide(RocketIcon)
}, {
  id: 'car',
  label: 'Car',
  Icon: lucide(CarIcon)
}, {
  id: 'leaf',
  label: 'Leaf',
  Icon: lucide(LeafIcon)
}];
export function ProfileIcon({
  icon,
  className
}: {
  icon: ProfileIconId;
  className?: string;
}) {
  const entry = PROFILE_ICONS.find(i => i.id === icon) ?? PROFILE_ICONS[0];
  const {
    Icon
  } = entry;
  return <Icon className={className} data-id="element-261" data-mp="32wom781taj7u" />;
}